import { ChangeEvent } from 'react';

export const formatDateOfBirth = (
	event: ChangeEvent<HTMLInputElement>,
	handleInputChange: (event: ChangeEvent<HTMLInputElement>) => void
) => {
	let { value, selectionStart } = event.target;
	const oldLength = value.length;

	value = value.replace(/\D/g, '');

	const day = value.slice(0, 2);
	const month = value.slice(2, 4);

	if (day && parseInt(day) > 31) {
		value = '31' + value.slice(2);
	}

	if (month && parseInt(month) > 12) {
		value = value.slice(0, 2) + '12' + value.slice(4);
	}

	if (value.length > 2 && value.length <= 4) {
		value = `${value.slice(0, 2)}/${value.slice(2)}`;
	} else if (value.length > 4) {
		value = `${value.slice(0, 2)}/${value.slice(2, 4)}/${value.slice(4)}`;
	}

	const newLength = value.length;
	event.target.value = value;
	selectionStart = selectionStart ? selectionStart + (newLength - oldLength) : 0;
	event.target.setSelectionRange(selectionStart, selectionStart);

	handleInputChange(event);
};
